import { call, put } from 'redux-saga/effects';
import { backendClient } from '../../../services/api/backend-client';
import { setSessionCrmContact } from '../../../state/callSessions/callSessionsSlice';
import { updateCallSessionAction } from '../../callSessions/updateCallSession/action';
import bugsnagClient from '../../../services/bugsnag/bugsnag';

export function* lookupCrmContactSaga(action) {
    const { crm, phone, sessionId } = action.payload;
    try {
        const { data } = yield call(
            [backendClient, backendClient.get],
            `integrations/${crm}/contact/lookup`,
            { params: { phone } }
        );
        if (data?.contact && sessionId) {
            yield put(setSessionCrmContact({ sessionId, contact: data.contact }));
            yield put(updateCallSessionAction());
        }
    } catch (err) {
        bugsnagClient.notify(err);
        console.error(`Failed to lookup ${crm} contact`, err?.response?.status, err?.message);
    }
}